import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass],
  selector: 'aux-table-panel',
  styles: `
    :host {
      display: block;
    }
  `,
  template: `
    <div
      class="overflow-hidden rounded-[8px] border border-aux-gray-dark bg-aux-gray-light"
      [ngClass]="classNames()"
    >
      <ng-content></ng-content>
    </div>
  `,
})
export class TablePanelComponent {
  classNames = input<string>();
}
